interface LoadingSpinnerProps {
	width?: number;
	height?: number;
}

export function LoadingSpinner({width, height}: LoadingSpinnerProps) {
	return (
		<div
			className="spinner"
			style={{
				width: width ? `${width}px` : '30px',
				height: height ? `${height}px` : '30px',
				border: '4px solid #333',
				borderTop: '4px solid #33BFFF',
				borderRadius: '50%',
				animation: 'spin 1s linear infinite'
			}}
		/>
	);
}
